if (!customElements.get('team-order-details')) {
  customElements.define(
    'team-order-details',
    class TeamOrderDetails extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.dataset.formId);
        this.container = this.closest('.product__team-order-details');
        this.toggle = this.container ? this.container.querySelector('[data-team-order-toggle]') : null;
        this.details = this.closest('details');
        this.fields = Array.from(this.querySelectorAll('[data-team-order-field]'));
        this.requiredFields = Array.from(this.querySelectorAll('[data-team-order-required]'));

        if (!this.form || this.requiredFields.length === 0) return;

        this.updateState();

        if (this.toggle) {
          this.toggle.addEventListener('change', this.updateState.bind(this));
        }

        if (this.details) {
          this.details.addEventListener('toggle', () => {
            if (!this.isActive && this.details.open) this.details.open = false;
          });
        }

        this.form.addEventListener('submit', this.validate.bind(this), true);
        this.requiredFields.forEach((field) => {
          field.addEventListener('input', () => this.setFieldError(field, false));
        });
      }

      updateState() {
        this.isActive = Boolean(this.toggle && this.toggle.checked);

        if (this.container) this.container.classList.toggle('is-active', this.isActive);
        if (this.details) this.details.open = this.isActive;

        this.fields.forEach((field) => {
          field.disabled = !this.isActive;
        });

        this.requiredFields.forEach((field) => {
          field.required = this.isActive;
          field.setAttribute('aria-required', this.isActive ? 'true' : 'false');
          this.setFieldError(field, false);
        });
      }

      validate(event) {
        if (!this.isActive) return;

        const firstInvalidField = this.requiredFields.find((field) => !field.value.trim());

        this.requiredFields.forEach((field) => {
          this.setFieldError(field, !field.value.trim());
        });

        if (!firstInvalidField) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        if (this.details) this.details.open = true;

        firstInvalidField.focus();
      }

      setFieldError(field, hasError) {
        field.setAttribute('aria-invalid', hasError ? 'true' : 'false');

        const fieldWrapper = field.closest('.team-order-details__field');
        const error = fieldWrapper ? fieldWrapper.querySelector('[data-team-order-error]') : null;

        if (error) error.hidden = !hasError;
      }
    }
  );
}
